/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AdminRegenerateUserPinPathParameters } from 'api/actions/admin-regenerate-user-pin/admin-regenerate-user-pin-path-parameters';
import { AdminRegenerateUserPinResponse } from 'api/actions/admin-regenerate-user-pin/admin-regenerate-user-pin-response';

type AdminRegenerateUserPinQueryParameters = Record<string, any>;

/**
 * The path of the AdminRegenerateUserPin action.
 */
export const adminRegenerateUserPinActionPath = new SweetPath<keyof AdminRegenerateUserPinPathParameters>(
  '/admin/custom/regenerate-user-pin/{userId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized AdminRegenerateUserPin actions.
 */
export default function createAdminRegenerateUserPinAction(axios: AxiosInstance) {
  return function adminRegenerateUserPinAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: AdminRegenerateUserPinPathParameters;
    query?: AdminRegenerateUserPinQueryParameters;
  }) {
    const path = adminRegenerateUserPinActionPath.insert(parameters);

    return axios.post<AdminRegenerateUserPinResponse, AdminRegenerateUserPinResponse>(path, { params: query, headers });
  };
}
